export class FilterParameter {
    private paramValue: any;
    private _initValue: any;

    constructor(private caption: string, private name: string) {}

    public value(val?: any): any {
        if (val === undefined) {
            return this._initValue === undefined ? this.paramValue : this._initValue;
        } else {
            return (this.paramValue = val);
        }
    }

    public getCaption(): string {
        return this.caption;
    }

    public getName(): string {
        return this.name;
    }

    public visit(visitor: IFilterParameterVisitor) {
        const typeName = this['constructor']['name'];
        const methodName = 'visit' + typeName;
        const method = visitor[methodName];
        if (!method) {
            throw 'Not Implimented FilterParameter:visit ' + typeName;
        }
        method(this);
    }

    public initValue(value?: any) {
        if (arguments.length === 0) {
            return this._initValue;
        } else {
            return (this._initValue = value);
        }
    }
}

export interface IFilterParameterVisitor {
    visitNumericFilterParameter(param: NumericFilterParameter);

    visitListValueParameter(param: ListValueParameter);

    visitSelectParameter(param: SelectParameter);

    visitCheckParameter(param: CheckParameter);

    visitValueParameter(param: ValueParameter);
}

export class NumericFilterParameter extends FilterParameter {
    constructor(caption: string, name: string) {
        super(caption, name);
    }
}

export class ValueParameter extends FilterParameter {
    constructor(caption: string, name: string) {
        super(caption, name);
    }
}

export class ListValueParameter extends FilterParameter {
    constructor(caption: string, name: string) {
        super(caption, name);
    }
}

export class SelectParameter extends FilterParameter {
    constructor(caption: string, name: string) {
        super(caption, name);
    }
}

export class CheckParameter extends FilterParameter {
    constructor(caption: string, name: string) {
        super(caption, name);
    }
}
